export const blue = '#1886c5'
export const lighterBlue = '#2497d9'
export const black = '#43494f'
export const gray = '#cccccc'
